import React from 'react'
import { Control, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import { CompanyId, GoalWithProgress, UserCompanyDto } from '../../../../services/api.types'
import ChallengePoints from '../ChallengePoints/ChallengePoints'
import ChallengeTotalPointsIncludes from '../ChallengeTotalPoints/ChallengeTotalPointsIncludes'
import YumMediumTitle from '../../../../components/YumMediumTitle/YumMediumTitle'

interface ChallengeStepPointsProps {
  register: UseFormRegister<FormData>
  control: Control<FormData>
  watch: UseFormWatch<FormData>
  setValue: UseFormSetValue<FormData>
  errors: FieldErrors<FormData>
  activityType: CustomTypeCategory
  goals: GoalWithProgress[]
  companyId: CompanyId
  userCompanies: UserCompanyDto[]
  isEdit: boolean
}

/**
 * Component for configuring points settings.
 * Shown as a separate step after Activity type selection.
 * Only displayed when activity type is POINTS.
 * Note: TOTAL_POINTS is now handled in a separate step (ChallengeStepTotalPoints).
 */
export default function ChallengeStepPoints(props: ChallengeStepPointsProps) {
  const { control, watch, register, setValue, errors, activityType, goals, companyId, userCompanies, isEdit } = props

  // Only show this step for POINTS activity type
  if (activityType !== CustomTypeCategory.POINTS) {
    return null
  }

  return (
    <>
      {/* <YumMediumTitle>{t`Wellness points`}</YumMediumTitle> */}
      <ChallengePoints
        control={control}
        watch={watch}
        register={register}
        setValue={setValue}
        errors={errors}
        userCompanies={userCompanies}
        isEdit={isEdit}
      />
      <ChallengeTotalPointsIncludes
        control={control}
        watch={watch}
        register={register}
        setValue={setValue}
        errors={errors}
        goals={goals}
        companyId={companyId}
      />
    </>
  )
}
